import { HTMLAttributes, useEffect, useMemo } from 'react'

import { LenisProvider } from '@/contexts/lenis'
import { SchemaProvider } from '@/contexts/schema'
import { useLoaderStore } from '@/store/loader'
import { pageHasHero, pageHasWebgl } from '@/utils/page'

import Footer from './footer'
import { WPPageData } from '@/types'

export type LayoutProps = HTMLAttributes<HTMLDivElement> & {
  pageProps?: WPPageData
}

const Layout = ({ pageProps, children, ...props }: LayoutProps) => {
  const schema = useMemo(() => pageProps?.breadcrumbs, [pageProps])
  const hasHero = useMemo(() => pageHasHero(pageProps), [pageProps])
  const hasWebgl = useMemo(() => pageHasWebgl(pageProps), [pageProps])
  const setLoaderState = useLoaderStore((state) => state.setState)

  useEffect(() => {
    if (!(hasHero || hasWebgl)) {
      setLoaderState({ pageLoaded: true, loaded: true })
    }
  }, [hasHero, hasWebgl, setLoaderState])

  return (
    <SchemaProvider schema={schema}>
      <LenisProvider {...props}>
        {children}
        <Footer />
      </LenisProvider>
    </SchemaProvider>
  )
}

export default Layout
